import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useCognitoAuth } from '@/contexts/AuthContext';

const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN as string | undefined;
const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined;

export function ForgotPasswordPage() {
  useCognitoAuth();

  useEffect(() => {
    const redirectUri = `${window.location.origin}/login`;
    if (COGNITO_DOMAIN && COGNITO_CLIENT_ID) {
      const url = `${COGNITO_DOMAIN}/forgotPassword?client_id=${COGNITO_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectUri)}`;
      window.location.href = url;
    }
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block">
            <img src="/logo.png" alt="BeanGo" className="h-12 w-auto mx-auto mb-4" />
          </Link>
          <h1 className="text-2xl font-bold text-foreground">Reset your password</h1>
          <p className="text-muted-foreground mt-2">
            Redirecting you to the password reset page...
          </p>
        </div>

        <div className="bg-card rounded-lg border border-border p-6 text-center">
          {!COGNITO_DOMAIN || !COGNITO_CLIENT_ID ? (
            <div className="mb-4 p-3 bg-destructive/10 border border-destructive/20 rounded-lg text-destructive text-sm">
              Password reset is not configured. Please contact support.
            </div>
          ) : (
            <p className="text-sm text-muted-foreground mb-4">
              You should be redirected automatically. If nothing happens, click the button below.
            </p>
          )}

          {COGNITO_DOMAIN && COGNITO_CLIENT_ID && (
            <a
              href={`${COGNITO_DOMAIN}/forgotPassword?client_id=${COGNITO_CLIENT_ID}&redirect_uri=${encodeURIComponent(`${window.location.origin}/login`)}`}
              className="inline-block w-full bg-primary text-primary-foreground py-2 rounded-lg font-semibold hover:bg-primary/90 transition-colors text-center"
            >
              Go to password reset
            </a>
          )}
        </div>

        <p className="mt-6 text-center text-sm text-muted-foreground">
          Remember your password?{' '}
          <Link to="/login" className="text-primary hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}